export default function prepMarkdown(markdown) {
  // react-markdown does not render Markdown if its in the same line as HTML
  return markdown.split(">").join(">\n");
}
